<template
  element-loading-text="拼命加载中"
  element-loading-spinner="el-icon-loading"
  v-loading="loading"
>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { usercenterinfo } from '@/api/home'
export default {
  data() {
    return {}
  },
  watch: {},
  methods: {
    usercenterinfo() {
      usercenterinfo().then((res) => {
        if (res.data.code == 0) {
          localStorage.setItem('info', JSON.stringify(res.data.data))
          localStorage.setItem('type', res.data.data.schoolType)
          localStorage.setItem('authSource', res.data.data.authSource)
        }
      })
    },
  },
  components: {
    // 声明子组件名字
  },
  created() {
    if (this.$route.query.token) {
      localStorage.setItem('token', this.$route.query.token)
      localStorage.setItem('url', this.$route.query.url)
    }
    if (this.$route.query.roleId) {
      localStorage.setItem('roleId', this.$route.query.roleId)
    }

    // if (this.$route.path !== '/user/login') {
    //   this.usercenterinfo()
    // }
    this.usercenterinfo()
  },
  computed: {},
  mounted() {
    //			window.addEventListener( 'beforeunload', e => this.set() );
  },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue